<template>
  <div class="modal">
    <div class="modal-content">
      <div class="entity-images-container">
        <div class="img-container">
          <img class="entity-img1" v-if="entityOneLogo==''" src="@/assets/orgInfo.svg" />
          <img class="entity-img1" v-else :src="entityOneLogo" />
          <img class="entity-img2" v-if="entityTwoLogo==''" src="@/assets/orgInfo.svg" />
          <img class="entity-img2" v-else :src="entityTwoLogo" />
        </div>
        <div class="arrow-container">
          <img src="@/assets/arrow1.svg" class="arrow-left" />
          <img src="@/assets/arrow2.svg" class="arrow-right" />
        </div>
        <div class="image-cover">
        </div>
      </div>
      <div class="message-text">
        Active Legal Entity changed
      </div>
      <button class="btn-popup" type="button" @click="goBack">
        Done
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String
    },
    btnText: {
      type: String
    },
    closable: {
      type: Boolean,
      default: false
    },
    entityOneLogo: {
      type: String,
      default: ''
    },
    entityTwoLogo: {
      type: String,
      default: ''
    }
  },
  methods: {
    goBack() {
      this.$emit('back');
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/scss/_variables.scss';

.entity-images-container {
  position: relative;
  width: 280px;
  height: 80px;
  background-color: white;
  .img-container {
    -webkit-animation: changeEntity 0.6s normal 1;
    animation: changeEntity 0.6s normal 1;
    display: flex;
    position: absolute;
    animation-delay: 0.8s;
    -webkit-animation-delay: 0.8s;
    animation-fill-mode: forwards;
    -webkit-animation-fill-mode: forwards;

  }
  .image-cover {
    height: 80px;
    width: 280px;
    z-index: 20;
    position: absolute;
    opacity: 1;
    background: radial-gradient(circle, transparent 0px, transparent 40px, white 40px);
  }
  .arrow-container {
    position: absolute;
  }
  .entity-img1 {
    position: absolute;;
    // margin: auto;
    height: 80px;
    width: 80px;
    display: flex;
    // left: 30%;
    background-color: white;
    border-radius: 50%;
    z-index: 5;
    overflow: hidden;
  }
  .entity-img2 {
    position: absolute;;
    // margin: auto;
    height: 80px;
    width: 80px;
    display: flex;
    left: 100px;
    background-color: white;
    border-radius: 50%;
    z-index: 5;
    overflow: hidden;
  }
}
@-webkit-keyframes changeEntity {
    0% {
        left: 50px;
    }
    100% {
        left: 100px;
    }
}
@keyframes changeEntity {
    0% {
        left: 50px;
    }
    100% {
        left: 100px;
    }
}
.arrow-left {
  transform: rotate(90deg);
  height: 25px;
  width: 25px;
  position: absolute;
  -webkit-animation: moveLeftArrow 0.6s normal 1;
  animation: moveLeftArrow 0.6s normal 1;
  display: flex;
  animation-delay: 0.8s;
  -webkit-animation-delay: 0.8s;
  animation-fill-mode: forwards;
  -webkit-animation-fill-mode: forwards;
  top: 55px;
  left: 125px;
  z-index: 10;
  margin-top: 2px;
  opacity: 0;
}
.arrow-right {
  transform: rotate(-90deg);
  height: 25px;
  width: 25px;
  position: absolute;
  -webkit-animation: moveRightArrow 0.6s normal 1;
  animation: moveRightArrow 0.6s normal 1;
  display: flex;
  animation-delay: 0.8s;
  -webkit-animation-delay: 0.8s;
  animation-fill-mode: forwards;
  -webkit-animation-fill-mode: forwards;
  top: 45px;
  left: 140px;
  z-index: 10;
  opacity: 0;
}
@-webkit-keyframes moveLeftArrow {
    0% {
        left: 125px;
        opacity: 1;
    }
    100% {
        left: 110px;
        opacity: 0;
    }
}
@keyframes moveLeftArrow {
    0% {
        left: 125px;
        opacity: 1;
    }
    100% {
        left: 110px;
        opacity: 0;
    }
}
@-webkit-keyframes moveRightArrow {
    0% {
        left: 140px;
        opacity: 1;
    }
    100% {
        left: 155px;
        opacity: 0;
    }
}
@keyframes moveRightArrow {
    0% {
        left: 140px;
        opacity: 1;
    }
    100% {
        left: 155px;
        opacity: 0;
    }
}
.modal {
  display: block;
  position: fixed;
  z-index: 6;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: rgba(0,0,0,0.3);
}

/* Modal Content */
.modal-content {
  background-color: white;
  margin: 150px auto 0px auto;
  z-index: 20;
  width: 500px;
  height: 375px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 4px;
  padding: 30px 36px 36px 36px;

  .success-icon {
    margin-bottom: 40px;
  }

  .success-text {
    font-size: $font-size-l1;
    font-weight: 600;
    margin-bottom: auto;
  }

  .message-text {
    font-size: $font-size-l1;
    margin-bottom: auto;
    margin-top: auto;
  }

  .btn-popup {
    display: block;
    border-radius: 4px;
    min-width: 200px;
    padding: 0px 10px;
    height: 35px;
    background-color: $color-primary;
    color: $color-white;
  }
  .close-btn {
    position: relative;
    transform: scale(2);
    left: 235px;
    bottom: 5px;
    cursor: pointer;
  }
}
</style>
